module.exports = __webpack_public_path__ + "img/p2.842d2582.png";